const testimonials = [
  {
    id: 1,
    name: "HappyUser",
    title: "Buyer",
    org: "Fiverr",
    desc: "Fast delivery and provided exactly what I needed. I enjoyed working with the seller very much!",
  },
  {
    id: 2,
    name: "Sebastian Boe",
    title: "Buyer",
    org: "Fiverr",
    desc: "Perfectly completed the project in a timely manner. There was no need for Revision. Highly recommended!.",
  },
  {
    id: 3,
    name: "Md Maruf",
    title: "CEO",
    org: "CheckinBD",
    desc: "Really hard-working person. Deliver the work as promised. Planning to work more with this person.",
  },
];
export default testimonials;
